module.exports = __webpack_public_path__ + "static/media/temp_alert_small.cb7a00e0.png";